import React, {FC} from "react"

import {PerkboxLogo} from "@irati/ui/src/Logos"

import {LoginMobileBrandImg} from "./styled"
import {UnauthedHeader} from "../styled"

interface Props {
  businessLogoUrl?: string
}

const HeaderLoginMobile: FC<Props> = ({businessLogoUrl}) => {
  return (
    <UnauthedHeader>
      <PerkboxLogo id="logo-login-header" />
      {businessLogoUrl && <LoginMobileBrandImg alt="" src={businessLogoUrl} />}
    </UnauthedHeader>
  )
}

export default HeaderLoginMobile
